






















































































































































import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import SharedContentList from "@/components/shared-content/SharedContentList.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import Debug from "@/components/utility/Debug.vue";
import MActionList from "@/components/utility/mmmint/MActionList.vue";
import MDetailTable, {
  DetailTableTypeEnum,
  DetailTableVisualizationEnum,
  IMDetailTableConfig
} from "@/components/utility/mmmint/MDetailTable.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction, IAlert, IChips } from "@/components/utility/mmmint/MHeader.vue";
import RefsInvoiceParty from "@/components/utility/RefsInvoiceParty.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import SelectEntity from "@/components/utility/SelectEntity.vue";
import { getFlagEmoji, getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Address } from "@/models/address.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { ISignDocument, SignDocument } from "@/models/sign-document.entity";
import { ISignRequest, SignRequest } from "@/models/sign-request.entity";
import { SignDigitalSignatureViewModelGen } from "@/services/sign/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { FeatureModule } from "@/store/modules/feature.store";
import { PartnerModule } from "@/store/modules/partner";
import { RefsMessagesModule, RefsSignRequestModule, RefTypeMap } from "@/store/modules/refs.store";
import { SignModule } from "@/store/modules/sign.store";
import DocumentDetailEditorMixin from "@/views/sign/DocumentDetailEditorMixin.vue";
import ReportDocumentSignRequestDialog from "@/views/sign/ReportDocumentSignRequestDialog.vue";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import RefsSignRequest from "../utility/RefsSignRequest.vue";
import RefsVehicle from "../utility/RefsVehicle.vue";
import SignDocumentDetailTps from "./SignDocumentDetailTps.vue";
import SignDocumentDetailViewer from "./SignDocumentDetailViewer.vue";
import SelectUpdateTags from "../tag/SelectUpdateTags.vue";
import DocumentManageAccessDialog from "@/views/sign/DocumentManageAccessDialog.vue";
import SignDocumentForm from "@/views/sign/DocumentForm.vue";

@Component({
  components: {
    MHeader,
    MDetailViewGrid,
    MDetailTable,
    MActionList,
    LatestEntriesCardEmpty,
    Debug,

    ActivityCard: () => import("@/components/thg/ActivityCard.vue"),
    SignDocumentDetailViewer,
    SharedContentList,
    SignDocumentDetailTps,

    ConfirmActionDialog,
    ReportDocumentSignRequestDialog,

    DocumentManageAccessDialog,

    SelectEntity,
    SelectUpdateTags,
    RefsSelect,
    RefsVehicle,
    RefsInvoiceParty,
    RefsSignRequest,
    SignDocumentForm
  },
  filters: {
    getFlagEmojiByLanguage,
    getFlagEmoji
  }
})
export default class SignDocumentDetail extends mixins(
  PartnerFallbackMixin,
  PermissionMixin,
  DocumentDetailEditorMixin
) {
  readonly RefsTypeMap = RefTypeMap;
  readonly SignDocument = SignDocument;
  readonly Address = Address;
  readonly formable = SignDocument;
  readonly DefaultTab = 0;
  readonly RefTypeMap = RefTypeMap;
  readonly RequestStatusEnum = RequestStatusEnum;

  @Prop()
  value!: ISignDocument;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  @Ref("signRequestDialog")
  signRequestDialog!: ReportDocumentSignRequestDialog;

  tab = 0;

  isDeleteDialogActive = false;

  documentManageAccessDialog = false;

  isUpdateDialogActive = false;

  isUpdateValid = false;

  isUpdateLoading = false;

  isRefsLoading = false;

  isDeleteLoading = false;

  isDocumentLoading = false;

  isSignatureLoading = false;

  isSignRequestLoading = false;

  isSignRequestsLoading = false;

  signature: SignDigitalSignatureViewModelGen | null = null;

  sharedContent: ISharedContent[] = [];

  signRequest: ISignRequest | null = null;

  signRequests: ISignRequest[] = [];

  get isLoading() {
    return (
      this.isRefsLoading ||
      this.isDeleteLoading ||
      this.isDocumentLoading ||
      this.isSignatureLoading ||
      this.isSignRequestLoading ||
      this.isSignRequestsLoading ||
      this.isUpdateLoading
    );
  }

  get isTpsActive() {
    return FeatureModule.isTpsActive && this.can(ActionEnum.READ, ResourceEnum.TPS);
  }

  get alerts(): IAlert[] {
    const alerts: IAlert[] = [];

    return alerts;
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      key: "createdReadable",
      text: this.value.timestamp.createdReadable
    });

    if (this.value.isSigned) {
      chips.push({
        key: "signed",
        color: "success",
        text: $t("sign.DocumentDetail.signed")
      });
    } else if (this.value.isTemplate) {
      chips.push({
        key: "template",
        text: $t("sign.DocumentDetail.template")
      });
    }

    return chips;
  }

  get refsCategories(): BackendResourceEnum[] {
    return [];
  }

  get subtitle() {
    return $t("createdOn", { date: simpleDoubleDigitDate(this.value.timestamp.created) });
  }

  get breadCrumbs(): IBreadcrumb[] | undefined {
    if (this.hideBreadCrumbs) {
      return undefined;
    }

    const selected: IBreadcrumb[] = [];

    return selected;
  }

  onSharedContentUpdate(list: ISharedContent[]) {
    this.sharedContent.splice(0);
    this.sharedContent.push(...list);
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () => new GoToHelper(this.$router).goToDocumentDetail(this.value.id, this.value.partnerId)
      });
    }

    const sharedContent = this.sharedContent?.[0];
    if (sharedContent) {
      actions.push({
        text: $t("timeLine.ReportActivityBoxShareComponent.copy"),
        key: "copy",
        icon: "mdi-content-copy",
        color: "",
        exec: () => sharedContent.copyLinkToClipboard()
      });
    }

    actions.push({
      text: $t("sign.DocumentDetail.download"),
      key: "download",
      icon: "mdi-download-outline",
      color: "",
      loading: this.isDocumentLoading,
      exec: this.loadDocument
    });

    if (this.partner.partnerType === PartnerTypeEnum.BROKER) {
      actions.push({
        text: $t("sign.DocumentTable.access"),
        key: "access",
        icon: "mdi-account-outline",
        color: "",
        loading: this.isDocumentLoading,
        exec: this.startUpdateIsInternal
      });
    }

    if (this.can(ActionEnum.CREATE, ResourceEnum.SIGN) && !this.value.isSigned) {
      actions.push({
        text: $t("sign.DocumentDetail.requestSignature"),
        key: "request-signature",
        icon: "mdi-signature-freehand",
        color: "",
        exec: this.initializeSignatureRequestDialog
      });
    }

    if (this.can(ActionEnum.UPDATE, BackendResourceEnum.DOCUMENT)) {
      actions.push({
        text: $t("update"),
        key: "title",
        icon: "mdi-pencil",
        exec: this.onUpdateItem
      });
    }

    if (this.can(ActionEnum.DELETE, BackendResourceEnum.DOCUMENT) && this.value.isDeletable) {
      actions.push({
        text: $t("delete"),
        key: "title",
        icon: "mdi-trash-can",
        color: "red",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get bottomActions() {
    const actions: IAction[] = [];

    const sharedContent = this.sharedContent?.[0];
    if (sharedContent) {
      actions.push({
        text: $t("timeLine.ReportActivityBoxShareComponent.copy"),
        key: "copy",
        icon: "mdi-content-copy",
        color: "",
        exec: () => sharedContent.copyLinkToClipboard()
      });
    }

    actions.push({
      text: $t("sign.DocumentDetail.download"),
      key: "download",
      icon: "mdi-download-outline",
      color: "",
      loading: this.isDocumentLoading,
      exec: this.loadDocument
    });

    if (this.partner.partnerType === PartnerTypeEnum.BROKER) {
      actions.push({
        text: $t("sign.DocumentTable.access"),
        key: "access",
        icon: "mdi-account-outline",
        color: "",
        loading: this.isDocumentLoading,
        exec: this.startUpdateIsInternal
      });
    }

    if (this.can(ActionEnum.CREATE, ResourceEnum.SIGN) && !this.value.isSigned) {
      actions.push({
        text: $t("sign.DocumentDetail.requestSignature"),
        key: "request-signature",
        icon: "mdi-signature-freehand",
        color: "",
        exec: this.initializeSignatureRequestDialog
      });
    }

    if (this.can(ActionEnum.UPDATE, BackendResourceEnum.DOCUMENT)) {
      actions.push({
        text: $t("update"),
        key: "title",
        icon: "mdi-pencil",
        exec: this.onUpdateItem
      });
    }

    if (this.can(ActionEnum.DELETE, BackendResourceEnum.DOCUMENT) && this.value.isDeletable) {
      actions.push({
        text: $t("delete"),
        key: "title",
        icon: "mdi-trash-can",
        color: "red",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.DOCUMENT
    };
  }

  get to() {
    return [];
  }

  get detailTableConfig(): IMDetailTableConfig[] {
    const detailTableConfig: IMDetailTableConfig[] = [
      {
        key: "document.title",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      },
      {
        key: "document.description",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      },
      {
        key: "document.folder",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      }
    ];

    // Add Internal field for broker partners
    if (this.partner?.partnerType === PartnerTypeEnum.BROKER) {
      detailTableConfig.push({
        key: "document.isInternal",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.SLOT
      });
    }

    detailTableConfig.push({
      key: "document.timestamp.created",
      type: DetailTableTypeEnum.PROPERTY,
      visualization: DetailTableVisualizationEnum.DATE
    });

    if (this.value.isSigned) {
      detailTableConfig.push({
        key: "signature.timestamp.created",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.DATE
      });
      detailTableConfig.push({
        key: "signature.firstName",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
      detailTableConfig.push({
        key: "signature.lastName",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
    }

    return detailTableConfig;
  }

  get signatureDetailTableConfig(): IMDetailTableConfig[] {
    const detailTableConfig: IMDetailTableConfig[] = [];

    if (this.signature) {
      detailTableConfig.push({
        key: "signature.timestamp.created",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.DATE
      });
      detailTableConfig.push({
        key: "signature.firstName",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
      detailTableConfig.push({
        key: "signature.lastName",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
    }

    return detailTableConfig;
  }

  get signatureRequestDetailTableConfig(): IMDetailTableConfig[] {
    const detailTableConfig: IMDetailTableConfig[] = [];

    if (this.signRequest) {
      detailTableConfig.push({
        key: "signRequest.timestamp.created",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.DATE
      });
      detailTableConfig.push({
        key: "signRequest.recipient.firstName",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
      detailTableConfig.push({
        key: "signRequest.recipient.lastName",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
      detailTableConfig.push({
        key: "signRequest.recipient.companyName",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
      detailTableConfig.push({
        key: "signRequest.recipient.email",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      });
      detailTableConfig.push({
        key: "signRequest.recipient.validBy",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.DATE
      });
      detailTableConfig.push({
        key: "signRequest.recipient.title",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.DATE
      });
      detailTableConfig.push({
        key: "signRequest.recipient.description",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.DATE
      });
      detailTableConfig.push({
        key: "signRequest.recipient.externalId",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.DATE
      });
    }

    return detailTableConfig;
  }

  async mounted() {
    await Promise.all([this.populateActivitiesWithMessages(), this.fetchSignature(), this.fetchSignRequests()]);
  }

  async populateActivitiesWithMessages() {
    const partnerId = this.value.partnerId;
    const documentId = this.value.id;
    await RefsMessagesModule.generateFrontendTimeLineElementsForMessagesAssociatedWithReference({
      refId: documentId,
      partnerId
    });
  }

  async fetchSignature() {
    this.signature = null;
    if (!this.can(ActionEnum.READ, ResourceEnum.SIGN)) {
      return;
    }

    try {
      this.isSignatureLoading = true;
      const partnerId = this.value.partnerId;
      const documentId = this.value.id;
      const signature = await SignModule.findOneByDocument({ partnerId, documentId });
      this.signature = signature;

      await this.fetchSignRequestOfSignature();
    } catch (e) {
      handleError(e);
    } finally {
      this.isSignatureLoading = false;
    }
  }

  async fetchSignRequests() {
    this.signRequests.splice(0);
    if (!this.can(ActionEnum.READ, ResourceEnum.SIGN)) {
      return;
    }

    try {
      this.isSignRequestsLoading = true;
      RefsSignRequestModule.setFilters([
        new PageFilterElement({
          key: "documents",
          operation: PageFilterOperationEnum.EQUAL,
          value: this.value.id
        })
      ]);

      await RefsSignRequestModule.fetchFirstPage({
        partnerId: this.value.partnerId
      }).catch(handleError);
      const signRequests = RefsSignRequestModule.filtered;

      this.signRequests.push(...signRequests);
    } catch (e) {
      handleError(e);
    } finally {
      this.isSignRequestsLoading = false;
    }
  }

  async fetchSignRequestOfSignature() {
    this.signRequest = null;
    if (!this.can(ActionEnum.READ, ResourceEnum.SIGN) || !this.signature) {
      return;
    }

    try {
      this.isSignRequestLoading = true;
      const partnerId = this.value.partnerId;
      const requestId = this.signature.requestId;
      if (requestId) {
        const signRequest = await new SignRequest({ partnerId, id: requestId }).fetch();

        if (signRequest.id) {
          this.signRequest = signRequest;
        }
      }
    } catch (e) {
      handleError(e);
    } finally {
      this.isSignRequestLoading = false;
    }
  }

  onDeleteItem() {
    this.isDeleteDialogActive = true;
  }

  onUpdateItem() {
    this.isUpdateDialogActive = true;
  }

  async loadDocument() {
    this.isDocumentLoading = true;
    try {
      await this.value.download();
    } catch (error) {
      handleError(error);
    } finally {
      this.isDocumentLoading = false;
    }
  }

  async initializeSignatureRequestDialog() {
    const partnerId = this.value.partnerId;
    const documentId = this.value.id;
    await this.signRequestDialog.initializeForSignDocument(partnerId, documentId);
  }

  async onDelete() {
    try {
      this.isDeleteLoading = true;

      await this.value.delete();

      this.$toast.success("👍");

      this.isDeleteDialogActive = false;

      this.$emit("deleted");
    } catch (e) {
      handleError(e);
    } finally {
      this.isDeleteLoading = false;
    }
  }

  async saveRefs() {
    this.isRefsLoading = true;
    await this.value
      .updatePartial({
        refs: this.value.refs
      })
      .catch(handleError);
    this.isRefsLoading = false;
  }

  async saveUpdate() {
    this.isUpdateLoading = true;

    const update = (this.$refs.signDocumentForm as SignDocumentForm).createDocumentDto;

    console.log("saveUpdate", update);
    try {
      await this.value.updatePartial({
        title: update.title,
        description: update.description,
        folder: update.folder,
        isShared: update.isShared,
        tagIds: update.tags.map(tag => tag.id) || []
      });

      this.isUpdateDialogActive = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isUpdateLoading = false;
    }
  }

  async onCloseSignRequestDialog() {
    await this.initialize(this.value);
  }

  startUpdateIsInternal() {
    this.documentManageAccessDialog = true;
  }
}
